import React from "react"
import PropTypes from "prop-types"
import { StyledDateField } from "./styles"
import moment from "moment"

const DefaultDateTimeField = ({ handleInputChange, handleInputBlur, ...rest }) => {
  const { name, value, min, max, placeholder, homepage, simpleForm } = rest

  const handleBlur = (event) => {
    if (handleInputBlur !== undefined) {
      handleInputBlur(name, event.target.value)
    }
  }

  const handleChange = (event) => {
    if (handleInputChange !== undefined) {
      handleInputChange(name, event.target.value)
    }
  }

  const defaultValue = value ? moment(value).format("YYYY-MM-DD HH:mm") : ""
  const minDate = min ? moment(min).format("YYYY-MM-DD HH:mm") : ""
  const maxDate = max ? moment(max).format("YYYY-MM-DD HH:mm") : ""

  return (
    <StyledDateField
      type="datetime-local"
      value={defaultValue}
      placeholder={placeholder}
      min={minDate}
      max={maxDate}
      step={300}
      onChange={handleChange}
      onBlur={handleBlur}
      homepage={homepage}
      simpleForm={simpleForm}
    />
  )
}

DefaultDateTimeField.propTypes = {
  handleInputChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string
}

DefaultDateTimeField.defaultProps = {
  handleInputChange: undefined,
  placeholder: ""
}

export default DefaultDateTimeField
